// extracted by mini-css-extract-plugin
export default {"page":"page_page__moPQ6","main":"page_main__fwZRh","primary":"page_primary__v-WRD","secondary":"page_secondary__-HHVS","footer":"page_footer__YhUeq"};